import { useState, useEffect } from 'react';
import { useInterviewInfo } from './useInterviewInfoHook';

export const useInterviewLabels = (ticket) => {
    const [retType, cliType, province] = useInterviewInfo(ticket);

    const [returnType, setReturnType] = useState(null);
    const [clientType, setClientType] = useState(null)

    useEffect(() => {        
        setReturnType(retType ? `Tickets.Labels.ReturnTypeContent.${retType}` : null);
    }, [retType])

    useEffect(() => {
        setClientType(cliType ? `Tickets.Labels.ClientTypeContent.${cliType}` : null);
    }, [cliType])

    return [returnType, clientType, province];
}
